import Inputmask from 'inputmask';

const maskList = {
  price: {
    regex: '₺ [0-9]*\\,?([0-9]{0,2})',
    placeholder: '0',
  },
  priceWithoutSymbol: {
    regex: '[0-9]*\\,?([0-9]{0,2})',
    placeholder: '',
  },
  percent: {
    regex: '% [0-9]{0,2}',
    placeholder: '0',
  },
  number: {
    mask: '9{1,}',
    placeholder: '0',
  },
  barcode: {
    regex: '[0-9A-Za-z-]*',
    placeholder: '',
  },
  priceDecimalGroup: {
    alias: 'decimal',
    rightAlign: false,
    scale: 3,
    digits: 2,
    groupSeparator: '.',
    radixPoint: ',',
    autoGroup: true,
    placeholder: '',
  },
};

export default {
  bind: (el, binding) => {
    const props = maskList[binding.value] || {
      ...binding.value,
    };

    props.autoUnmask = el.attributes.autounmask;
    props.showMaskOnFocus = true;
    props.showMaskOnHover = true;

    Inputmask(props).mask(el);
  },
};
